import React from "react";
import { Form } from "react-bootstrap";
import { FormattedMessage, MessageDescriptor } from "react-intl";

export type ErrorFieldMessageProps =
  | { message: string }
  | (MessageDescriptor & { values?: Record<string, any> });

export const ErrorFieldMessage: React.FC<ErrorFieldMessageProps> = props => (
  <Form.Text className="text-danger" style={{ marginTop: 8, display: "block" }}>
    {"message" in props ? props.message : <FormattedMessage {...props} />}
  </Form.Text>
);
